// extracted by mini-css-extract-plugin
export default {"heading":"CommProfJoinPage_heading__sP4w8","content":"CommProfJoinPage_content__NIf06"};